import { Navigate, Route, Routes } from 'react-router';

import CartContainer from './Containers/CartContainer';
import CheckoutContainer from './Containers/CheckoutContainer';
import CheckoutSuccessContainer from './Containers/CheckoutSuccessContainer';
import CheckoutRedirectHandler from './CheckoutRedirectHandler';

const CheckoutRoutes = () => (
  <Routes>
    {/* Temporary redirections for magic links which use old routes */}
    <Route
      element={<Navigate replace to="/checkout/haircare/account-details" />}
      path="account-details"
    />
    <Route element={<Navigate replace to="/checkout/haircare/payment" />} path="payment" />

    <Route path=":category">
      <Route
        element={
          <CheckoutRedirectHandler>
            <CartContainer />
          </CheckoutRedirectHandler>
        }
        index
      />
      <Route
        element={
          <CheckoutRedirectHandler>
            <CheckoutContainer />
          </CheckoutRedirectHandler>
        }
        path="account-details"
      />
      <Route
        element={
          <CheckoutRedirectHandler>
            <CheckoutContainer />
          </CheckoutRedirectHandler>
        }
        path="shipping-address"
      />
      <Route
        element={
          <CheckoutRedirectHandler>
            <CheckoutContainer />
          </CheckoutRedirectHandler>
        }
        path="payment"
      />
      <Route
        element={
          <CheckoutRedirectHandler>
            <CheckoutContainer />
          </CheckoutRedirectHandler>
        }
        path="wait-payment-confirmation"
      />
    </Route>

    <Route element={<CheckoutSuccessContainer />} path="success" />

    {/*
     * Catch all for marketing redirections like magic links with UTMs
     * We want old links pointing to previous routes like /checkout?utm_source=toto
     * To be redirected to /checkout/haircare?utm_source=toto
     */}
    <Route element={<Navigate replace to="/checkout/haircare" />} path="*" />
  </Routes>
);

export default CheckoutRoutes;
